import { RouteItem } from '@eastcoal/router/types/route'

import { SupportLayout } from '../layouts'
import { homeRoute } from '../pages/Home/route'
import { searchRoute } from '../pages/Search/route'

export const routes: RouteItem[] = [
  {
    element: <SupportLayout />,
    children: [homeRoute, searchRoute]
  }
]
